import React, { Component } from 'react';

import * as MicrosoftGraph from "@microsoft/microsoft-graph-client";
import { IPersonaProps } from "office-ui-fabric-react";
import { connect } from "react-redux";
import { IRootState } from "../store";
import ApiService from "./ApiService";
import UserSelectorBase, { UserOption } from './UserSelectorBase';

interface UserSelectorCDBProps {
    className: string;
    label: string;
    selectedUsers?: UserOption[];
    onSelectionChanged: (selectedUsers: UserOption[]) => void;
    disabled: boolean;
    multiSelect: boolean;

    graphClient: MicrosoftGraph.Client;
    apiService: ApiService;
}

interface UserSelectorCDBState {
    selectedItems: IPersonaProps[];
}

class UserSelector extends Component<UserSelectorCDBProps, UserSelectorCDBState> {
    static displayName = UserSelector.name;

    constructor(props: UserSelectorCDBProps) {
        super(props);

        this.state = {
            selectedItems: []
        };
    }

    componentDidMount(): void {

    }


    componentDidUpdate(prevProps: Readonly<UserSelectorCDBProps>, prevState: Readonly<UserSelectorCDBState>, snapshot?: any): void {

    }

    private fetchUserOptions = async (filter: string): Promise<UserOption[]> => {

        let users: UserOption[] = [];

        let filterString = "";
        if (filter && filter !== "") {
            filterString = filterString + `startsWith(displayName,'${filter}') or startsWith(surname,'${filter}') or startsWith(userPrincipalName,'${filter}')`;
        }

        let reqBuilder = this.props.graphClient.api("/users");
        reqBuilder = reqBuilder.filter(filterString).top(300);
        const response = await reqBuilder.get();
        users = response.value;

        return users;
    };

    render(): JSX.Element {
        return (
            <UserSelectorBase
                className={this.props.className}
                label={this.props.label}
                selectedUsers={this.props.selectedUsers}
                onSelectionChanged={this.props.onSelectionChanged}
                disabled={this.props.disabled}
                multiSelect={this.props.multiSelect}
                textExtraDetails="Search by display name, surname or UPN"
                fetchUsers={this.fetchUserOptions} />
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { className: string, label: string, selectedUsers?: UserOption[], onSelectionChanged(selectedUsers: UserOption[]): void, disabled: boolean, multiSelect: boolean, additionalFilter?: undefined | "Teacher" }): UserSelectorCDBProps => {
        return {
            className: ownProps.className,
            label: ownProps.label,
            selectedUsers: ownProps.selectedUsers,
            onSelectionChanged: ownProps.onSelectionChanged,
            disabled: ownProps.disabled,
            multiSelect: ownProps.multiSelect,

            graphClient: state.auth.graphClient,
            apiService: state.auth.apiService
        };
    }
)(UserSelector)